'use client';

import { useEffect, useRef } from 'react';
import { pushToDataLayer } from './ga-core';

/**
 * 住所登録フロー用のGAトラッキングユーティリティ
 */
export const AddressTracker = {
  // 住所登録開始を記録（RAFFLEサイト側で呼び出し）
  trackStart: (source?: string, lotteryId?: number) => {
    pushToDataLayer('address_registration_start', {
      category: 'address_registration',
      label: 'address_button_click',
      engagement_value: 1,
      source: source || 'unknown',
      lottery_id: lotteryId,
    });
  },
  // 住所登録のための外部サイト（butterfly.fan）への遷移を記録
  trackExternalRedirect: (callbackUrl: string, lotteryId?: number) => {
    pushToDataLayer('address_external_redirect', {
      category: 'address_registration',
      label: 'redirect_to_address_site',
      engagement_value: 1,
      callback_url: callbackUrl,
      lottery_id: lotteryId,
    });
  },
  // 住所登録完了を記録（RAFFLEサイトに戻った時に呼び出し）
  trackComplete: (source?: string, lotteryId?: number) => {
    pushToDataLayer('address_registration_complete', {
      category: 'address_registration',
      label: 'address_registration_success',
      engagement_value: 1,
      source: source || 'unknown',
      lottery_id: lotteryId,
    });
  },
};

/**
 * 住所登録フロー開始時のトラッキング用コンポーネント
 * このコンポーネントがマウントされたときに一度だけイベントを送信
 */
export function SendGAAddressRegistrationStart({ source, lotteryId }: { source?: string; lotteryId?: number }) {
  const sendingRef = useRef(false);

  useEffect(() => {
    if (sendingRef.current) return;
    sendingRef.current = true;
    AddressTracker.trackStart(source, lotteryId); // AddressTracker のメソッドを呼び出す
  }, [source, lotteryId]);

  return null;
}

/**
 * 住所登録完了時のトラッキング用コンポーネント
 * このコンポーネントがマウントされたときに一度だけイベントを送信
 */
export function SendGAAddressRegistrationComplete({ source, lotteryId }: { source?: string; lotteryId?: number }) {
  const sendingRef = useRef(false);

  useEffect(() => {
    if (sendingRef.current) return;
    sendingRef.current = true;
    AddressTracker.trackComplete(source, lotteryId); // AddressTracker のメソッドを呼び出す
  }, [source, lotteryId]);

  return null;
}
